<template>
    <div class="response-content" v-if="datas" v-model="datas">
        <div class="row">
            <div class="col-auto response-items">
                <h2 class="response-title"> {{datas.city}}</h2>
                <div class="response-item" v-for="files in datas.files">
                    <a :href="files.url" class="btn" download>
                        <i class="icon icon-xls"></i>
                        <span>{{files.name}}</span>
                    </a>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['value'],
    data () {
        return {}
    },
    computed: {
        datas: {
            get () {
                return this.value.data
            }
        }
    }
}
</script>
